import { createSelector } from 'reselect';
import IpcEquipmentPoolsPredesResdesAnalysisIpcPalletBoxIbColumns
  from '../../containers/IpcEquipmentPoolsPredesResdesAnalysisIpcPalletBoxIbColumns';
import ReportDefinitions from '../../../../../../../common/config/ReportDefinitions';

export const getGeneratedOnDateTime =
  state => state.reporting.IPC_PALLET_BOX_IB_PREDES_RESDES_ANALYSIS.metadata.generatedOnDateTime;

export const getIsLoading =
  state => state.reporting.IPC_PALLET_BOX_IB_PREDES_RESDES_ANALYSIS.isLoading;

export const getData =
  ReportDefinitions.IPC_PALLET_BOX_IB_PREDES_RESDES_ANALYSIS.getDataFunction();

export const getColumns =
  createSelector(getData, IpcEquipmentPoolsPredesResdesAnalysisIpcPalletBoxIbColumns);
